import ApiService from '../api.services';

const ServicesService = {
    list: async function () {
        try {
            const response = await ApiService.get('/api/services');
            return response.data;
        } catch (error) {
            throw error;
        }
    },
    // Serviços da tela de reversa: a Reversa Consolidada só vem para o cliente que a tem habilitada.
    reverse: async function (customer) {
        try {
            const query = customer ? `?customer=${encodeURIComponent(customer)}` : '';
            const response = await ApiService.get(`/api/services/reverse/list${query}`);
            return response.data;
        } catch (error) {
            throw error;
        }
    },
    get: async function (id) {
        try {
            const response = await ApiService.get(`/api/services/${id}`);
            return response.data;
        } catch (error) {
            throw error;
        }
    },
    code: async function (id) {
        try {
            const response = await ApiService.get(`/api/services/code/${id}`);
            return response.data;
        } catch (error) {
            throw error;
        }
    },
    upload: async function (file) {
        let formData = new FormData();
        formData.append(`files[0]`, file.raw);
        const response = await ApiService.post('/api/servicegroup/upload', formData, {
            'Content-Type': 'multipart/form-data'
        });
        return response.data;

    },
    add: async function (form) {
        try {
            const data = {
                service: form
            }
            const res = await ApiService.post('/api/services', data);
            return res.data;
        } catch (error) {
            throw error;
        }
    },
    contract: async function (customer) {
        try {
            const res = await ApiService.get(`/api/services/contract/${customer}`);
            return res.data;
        } catch (error) {
            throw error;
        }
    },
    actives: async function () {
        try {
            const res = await ApiService.get(`/api/services/actives/list`);
            return res.data;
        } catch (error) {
            throw error;
        }
    },
    update: async function (id, form) {
        const data = {
            service: form
        }
        try {
            const response = await ApiService.put(`/api/services/${id}`, data);
            return response.data;
        } catch (error) {
            throw error;
        }
    },
    aditional: async function (id) {
        try {
            const response = await ApiService.get(`/api/services/${id}/aditional`);
            return response.data;
        } catch (error) {
            throw error;
        }
    },
    updateAditional: async function (id, aditionalId, minimun) {
        try {
            const response = await ApiService.put(`/api/services/${id}/aditional/${aditionalId}`, { minimun });
            return response.data;
        } catch (error) {
            throw error;
        }
    },
    delete: async function (id) {
        try {
            const response = await ApiService.delete(`/api/services/${id}`);
            return response.data;
        } catch (error) {
            throw error;
        }
    },
    inactive: async function (id) {
        try {
            const response = await ApiService.post(`/api/services/inactive/${id}`);
            return response.data;
        } catch (error) {
            throw error;
        }
    },
    active: async function (id) {
        try {
            const response = await ApiService.post(`/api/services/active/${id}`);
            return response.data;
        } catch (error) {
            throw error;
        }
    },
};

export default ServicesService;

export { ServicesService };

